document.querySelectorAll('[id^="custom-tab-collections-"]').forEach(function (section) {
  var tabs   = section.querySelectorAll('.custom-tab-collections__tab');
  var panels = section.querySelectorAll('.custom-tab-collections__panel');

  tabs.forEach(function (tab, idx) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      panels[idx].classList.add('is-active');
    });
  });
});
